import autoBind from 'auto-bind';

import { AppView } from '@/models/api';
import { NewsEntry } from '@/models/home';

const GET_OPTIONS = {
    method: 'GET',
    headers: {
        Accept: 'application/json'
    }
};

const HEAD_OPTIONS = {
    method: 'HEAD'
};

const URLS_TEST = {
    appview: '/appview_test',
    messages: '/messages',
    news: '/news'
};

const URLS_PROD = {
    appview: '/appview_prod',
    messages: '/messages',
    news: '/news'
};

export default class ListoryApi {
    public baseUrl: string;
    public urls: any = URLS_TEST;

    constructor() {
        autoBind(this);
        this.baseUrl = process.env.VUE_APP_API_URL;
        this.urls = process.env.VUE_APP_API_ENV === 'prod' ? URLS_PROD : URLS_TEST;
    }

    private fetchWithTimeout(url: RequestInfo, options: object, timeout = 10000): Promise<{} | Response> {
        return Promise.race([
            fetch(url, options),
            new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), timeout))
        ]);
    }

    public async getMessages(): Promise<any> {
        try {
            const res = await fetch(this.baseUrl + this.urls.messages, GET_OPTIONS);
            return await res.json();
        } catch (error) {
            console.error(error);
            return {};
        }
    }

    public async getNews(lang?: string): Promise<NewsEntry> {
        try {
            const res = await fetch(this.buildUrl(this.urls.news, lang), GET_OPTIONS);
            return await res.json();
        } catch (error) {
            console.error(error);
            return undefined;
        }
    }

    public async getAppViewVersion(lang?: string): Promise<string> {
        try {
            const url = this.buildUrl(this.urls.appview, lang);
            const res = (await this.fetchWithTimeout(url, HEAD_OPTIONS, 500)) as Response;
            if (res && res.ok && res.headers.has('Last-Modified')) {
                return res.headers.get('Last-Modified');
            }
        } catch (error) {
            console.error(error);
            return undefined;
        }
    }

    public async getAppView(lang?: string): Promise<AppView> {
        try {
            const res = await fetch(this.buildUrl(this.urls.appview, lang), GET_OPTIONS);
            return await res.json();
        } catch (error) {
            console.error(error);
            return undefined;
        }
    }

    private buildUrl(path: string, lang?: string) {
        lang = lang === 'de' || lang === 'en' ? lang : 'de';
        return `${this.baseUrl}${path}?lang=${lang}`;
    }
}
